var map = {
	"./alicorp-logo.png": 2001,
	"./arcor-logo.png": 3756,
	"./coorporacion-rico-sac-logo.png": 2571,
	"./gloria-logo.png": 9065,
	"./laive-logo.png": 4806,
	"./lock-logo-color.svg": 5210,
	"./logo-icon.png": 6064,
	"./logo-icon2.png": 1696,
	"./logo-icon_1.png": 2104,
	"./logo.svg": 3576,
	"./nestle-logo.png": 984,
	"./palmas-logo.png": 6513,
	"./quimpac-logo.png": 2593,
	"./sanfernando-logo.png": 3992,
	"./slide-lock-1.png": 3905,
	"./spsa-logo.png": 4790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4961;